import React from "react";

const OfferItem = ({ offer, onOfferClick }) => {
  console.log(offer.device);

  const offerLink = () => {
    onOfferClick(offer);
  };


  return (

    <div className="flex flex-col bg-white shadow-lg rounded-2xl px-[22px] py-[22px] flex items-center mx-auto mt-[12px] fade-in">
      <div
        className="max-w-sm  relative flex items-center mx-auto mt-[8px]"

      >

        <img
          src={offer.picture}
          alt="Placeholder"

          className="w-[52px] h-[52px] rounded-lg object-cover"
        />
        <div className="ml-[16px]">
          <div className="flex flex-row items-center">
            <h2 className="text-base font-bold">{offer.name_short}</h2>
            <div class="bg-custom-blue text-white py-[1px] ml-[12px] px-[12px] text-[12px] bold bg-light-blue rounded-md">
              Free
            </div>
          </div>

          <p className="text-gray-800 font-primaryMedium">{offer.adcopy}</p>
        </div>

      </div>
      <a
        className="h-[38px] bg-red-200 w-full mt-[12px] flex flex-row items-center rounded-xl justify-center font-primaryMedium text-white bg-gradient-to-r from-dark-blue to-semi-blue"
        href={offer.link}
        target="_blank">
        <div className="">
          Procced
        </div>

      </a>

    </div>


  );
};

export default OfferItem;
